export default "__VITE_ASSET__62c199fc__"